import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import { Button, Icons, TracksUploader } from 'imdshared';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { TracksQueryBuilder, LibraryHeaderTools } from 'components/molecules';
import { createEmptyTrack } from 'imddata/actionTypes/tracks';
import GlobalTracksList from '../GlobalTracksList';
import { TrackMasteringReloader } from './TrackMasteringReloader';
const uploaderButtonStyle = css`
  width: inherit;
  justify-content: inherit;
`;

// TODO Move it in Modules

// const GROUP_BY_OPTIONS = [
//   { id: 'create_date', label: 'Date' },
//   { id: 'releases', label: 'Release' },
//   { id: 'artists', label: 'Artist' },
//   { divider: true },
//   { id: null, label: 'Do not group' },
// ];

interface TracksSearchProps {
  selectedTracks?: (string | number)[]; // Assuming track IDs are strings
  disabledTracks?: (string | number)[];
  hideCreateTrack?: boolean;
  hideUploadTrack?: boolean;
  leftChildren?: React.ReactNode;
  onChangeSelection?: (ids: number[]) => void;
  stickyTopThreshold?: number;
  respectTopConstraint?: boolean;
  isDisabled?: any;
  scrollElement?: HTMLElement;
  defaultSearchQuery?: {
    perPage?: number;
    by?: string;
    [key: string]: any; // Allow additional query properties
  };
}

interface SearchQuery {
  perPage: number;
  by?: string;
  [key: string]: any; // Allow additional query properties
}

const TracksSearch: React.FC<TracksSearchProps> = ({
  selectedTracks = [],
  disabledTracks = [],
  hideCreateTrack = false,
  hideUploadTrack = false,
  onChangeSelection,
  leftChildren = null,
  stickyTopThreshold = 0,
  respectTopConstraint = false,
  isDisabled,
  scrollElement,
  defaultSearchQuery = {},
}) => {
  const dispatch = useDispatch();
  const groupBy = 'create_date';
  const [filters, setFilters] = useState<any[]>([]); // Replace 'any' with a proper filter type if available
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    perPage: 30,
    by: groupBy,
  });

  useEffect(() => {
    if (defaultSearchQuery) {
      setSearchQuery((prev) => ({
        ...defaultSearchQuery,
        by: filters && filters.length ? undefined : groupBy,
        ...prev,
      }));
    }
  }, [defaultSearchQuery]);

  const onChangeFiltering = ({
    value: filters,
    searchQuery: newSearchQuery,
  }: {
    value: any[]; // Replace 'any' with a proper filter type if available
    searchQuery: SearchQuery;
  }) => {
    setFilters(filters);
    setSearchQuery(
      defaultSearchQuery
        ? {
          ...defaultSearchQuery,
          ...newSearchQuery,
          by: filters && filters.length ? undefined : groupBy,
        }
        : {
          ...newSearchQuery,
          by: filters && filters.length ? undefined : groupBy,
        }
    );
  };

  const { t } = useTranslation();

  const handleCreateEmptyTrack = () => {
    window.scrollTo({
      top: 0,
    });
    dispatch(createEmptyTrack({ data: {} }));
  };

  return (
    <>
      <TrackMasteringReloader query={searchQuery} />
      <LibraryHeaderTools
        renderQueryBuilder={TracksQueryBuilder}
        key="header"
        components={{ Left: leftChildren }}
        stickyTopThreshold={stickyTopThreshold}
        respectTopConstraint={respectTopConstraint}
        value={filters}
        // @ts-ignore
        onChangeFiltering={onChangeFiltering}
      >
        {!hideUploadTrack && (
          <TracksUploader>
            <Button
              onClick={() => {
                // fix requiring on click for styles?
              }}
              icon={Icons.actions.upload}
              text={t('import')}
              css={uploaderButtonStyle}
            />
          </TracksUploader>
        )}

        {!hideCreateTrack && (
          <Button
            testId="Library-CreateTrack"
            icon={Icons.actions.add}
            text={t('create-empty')}
            onClick={handleCreateEmptyTrack}
          />
        )}
      </LibraryHeaderTools>

      <GlobalTracksList
        key="tracks"
        scrollElement={scrollElement}
        onChangeSelection={onChangeSelection}
        selectedTracks={selectedTracks}
        disabledTracks={disabledTracks}
        isDisabled={isDisabled}
        filters={filters}
        searchQuery={searchQuery}
      />
    </>
  );
};

export default TracksSearch;
